export enum ShipmentListFiltersRegions {
  NorthAfrica = 'NAF',
  SouthAfrica = 'SAF',
  LatinAmerica = 'LAM',
  NorthAmerica = 'NAM',
  MiddleEastAsia = 'MEA',
  EastAsia = 'EAS',
  OceanicAsia = 'OAS',
  SouthEastAsia = 'SEA',
  Australia = 'AUS',
  MiddleEastEurope = 'MEE',
  WesternEurope = 'WEU',
  Unknown = 'UNKNOWN',
}
